<ng-template #template>
  <div class="svc-question__adorner">
    <div class="svc-question__content svc-question__content--in-popup">
      <ng-template [component]="{ name: componentName, data: componentData }"></ng-template>
      <div class="svc-question__dropdown-choices">
          <div *ngFor="let item of model.visibleChoices"class="svc-question__dropdown-choice">
            <ng-template [component]="{ name: getItemValueComponentName(item), data: getItemValueComponentData(item) }"></ng-template>
          </div>
    </div>

    </div>
  </div>
</ng-template>